import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/backend";
import { CONVERSATION_QUERY_KEY } from "@/lib/query/conversation/conversation.query.key";
import { MESSAGE_QUERY_KEY } from "./message.query.key";

type Platform = "Whatsapp" | "SMS" | "Boomer";

interface SendMessageParams {
  conversationId: string;
  body: string;
  platform: Platform;
  mediaUrls?: string[];
  messageTemplateId?: string;
}

const TOAST_KEY = "send-message";

export function useSendMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MESSAGE_QUERY_KEY, "send"],
    mutationFn: async ({
      conversationId,
      body,
      platform,
      mediaUrls,
      messageTemplateId,
    }: SendMessageParams) => {
      const channel = platform === "Whatsapp" ? "WHATSAPP" : platform === "SMS" ? "SMS" : "BOOMER";

      const res = await api.messageCrud.create({
        conversationId,
        body,
        channel,
        direction: "OUTBOUND",
        mediaUrls,
        messageTemplateId,
      });
      return res.data;
    },
    onMutate: () => {
      toast.loading("Bericht verzenden...", { id: TOAST_KEY });
    },
    onSuccess: (_data, variables) => {
      toast.success("Bericht verzonden", { id: TOAST_KEY });
      queryClient.invalidateQueries({
        queryKey: [MESSAGE_QUERY_KEY, "infinite", variables.conversationId],
      });
      queryClient.invalidateQueries({
        queryKey: [CONVERSATION_QUERY_KEY],
      });
    },
    onError: () => {
      toast.error("Bericht verzenden mislukt", { id: TOAST_KEY });
    },
  });
}
